import React from "react";
import { FeeType } from "~graphql/sdk";
import { Price } from "flicket-ui";
import { getTicketFeeProperties } from "./common.utils";

interface PriceWithFeeProps {
  price: number;
  currency: string;
  ticketType: any;
  showFees: boolean;
}

const PriceWithFee = ({
  price,
  currency,
  ticketType,
  showFees = false,
}: PriceWithFeeProps) => {
  if (!price) return <>Free</>;

  const { ticketFee, ticketFeeType, stadiumLevyFee } =
    getTicketFeeProperties(ticketType);

  if (!showFees || (ticketFee <= 0 && stadiumLevyFee <= 0)) {
    return <Price price={price} currency={currency} />;
  }

  const FeeComponent = ((price: number) => {
    const Component =
      ticketFeeType === FeeType.Percentage ? (
        <Price
          price={price * (ticketFee / 100) + stadiumLevyFee}
          currency={currency}
        />
      ) : (
        <Price price={ticketFee + stadiumLevyFee} currency={currency} />
      );

    return <>{Component} Fees</>;
  })(price);

  return (
    <>
      <Price price={price} currency={currency} /> {"\u002B"} {FeeComponent}
    </>
  );
};

export default PriceWithFee;
